// AdSlot — placeholder/renderer for Google AdSense ad units inside template
// layouts. When `publisherId` and `enabled` are both set, renders an
// <ins class="adsbygoogle"> element; otherwise renders a labelled placeholder
// so template previews communicate where the ad would appear.
import type { AdSlotKey } from "@/lib/seoMonitor";

type Props = {
  slot: AdSlotKey;
  enabled?: boolean;
  publisherId?: string | null;
  adSlotId?: string | null;
  label?: string;
  className?: string;
};

const SIZE_HINT: Record<AdSlotKey, string> = {
  header: "h-24",
  between_articles: "h-32",
  sidebar: "h-72",
  in_article: "h-40",
  sticky_footer: "h-16",
};

export default function AdSlot({ slot, enabled = false, publisherId, adSlotId, label, className }: Props) {
  if (!enabled) return null;
  const placeholder = `Ad — ${label ?? slot.replace(/_/g, " ")}`;

  if (publisherId && adSlotId) {
    return (
      <ins
        className={`adsbygoogle block ${className ?? ""}`}
        style={{ display: "block" }}
        data-ad-client={publisherId}
        data-ad-slot={adSlotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
        aria-label={placeholder}
      />
    );
  }

  return (
    <div
      role="complementary"
      aria-label={placeholder}
      className={`flex items-center justify-center rounded border border-dashed border-border bg-muted/30 text-[11px] uppercase tracking-wider text-muted-foreground ${SIZE_HINT[slot]} ${className ?? ""}`}
    >
      {placeholder}
    </div>
  );
}
